import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

import { withDevtools } from './middleware-utils';

export const MAX_AUTO_SHOW = 3;

interface TourState {
  viewCount: number;
  completedAt?: string;
  dismissedAt?: string;
}

interface TourGuideState {
  disabled: boolean;
  tours: Record<string, TourState>;

  disable: () => void;
  enable: () => void;
  incrementViewCount: (tourId: string) => void;
  markCompleted: (tourId: string) => void;
  reset: () => void;
}

export const useTourGuideStore = create<TourGuideState>()(
  withDevtools(
    'TourGuide',
    persist(
      set => ({
        disabled: false,
        tours: {},

        disable: () => set({ disabled: true }),
        enable: () => set({ disabled: false }),

        incrementViewCount: (tourId: string) =>
          set(state => ({
            tours: {
              ...state.tours,
              [tourId]: {
                ...(state.tours[tourId] ?? { viewCount: 0 }),
                viewCount: (state.tours[tourId]?.viewCount ?? 0) + 1,
              },
            },
          })),

        markCompleted: (tourId: string) =>
          set(state => ({
            tours: {
              ...state.tours,
              [tourId]: {
                ...(state.tours[tourId] ?? { viewCount: 0 }),
                completedAt: new Date().toISOString(),
              },
            },
          })),

        reset: () => set({ disabled: false, tours: {} }),
      }),
      {
        name: 'tour-guide-store',
        version: 1,
        storage: createJSONStorage(() => localStorage),
      }
    )
  )
);
